/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Result_Group_UncertainInputs */



/**
* | output |
* | --- |
* | "{count} actions did not complete or could not be confirmed" |
*
* @param {Chat_Tool_Result_Group_UncertainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_result_group_uncertain = /** @type {((inputs: Chat_Tool_Result_Group_UncertainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Result_Group_UncertainInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Aktionen wurden nicht abgeschlossen oder konnten nicht bestätigt werden`)
	return /** @type {LocalizedString} */ (`${i?.count} actions did not complete or could not be confirmed`)
});